import { RaceData } from "../../enrollment/models/race-data"
import { EthnicityData } from "../../enrollment/models/ethnicity-data"

export class EnrollmentViewModel {
    ACCHOLDERNAME: string = ""
    ACCOUNTNB: string = ""
    AGENTEMAIL: string = ""
    AGENTFN: string = ""
    AGENTID: string = ""
    AGENTLN: string = ""
    AGENTNAME: string = ""
    AgentSignature: string = ""
    APPADD1: string = ""
    APPADD2: string = ""
    APPCITY: string = ""
    APPDOB: any
    APPDT: any
    APPEMAIL: string = ""
    APPFN: string = ""
    APPGEN: string = ""
    APPLN: string = ""
    APPMI: string = ""
    APPST: string = ""
    APPZIP: string = ""
    ATESTPROOF: string = ""
    AUTHREPADD1: string = ""
    AUTHREPADD2: string = ""
    AUTHREPCITY: string = ""
    AUTHREPIND: string = ""
    AUTHREPNAME: string = ""
    AUTHREPPHONE: string = ""
    AUTHREPREL: string = ""
    AUTHREPCOPYIND: string = ""
    AUTHREPST: string = ""
    AUTHREPZIP: string = ""
    APPPHONE: string = ""
    CELLPHONE: string = ""
    COBBIN: string = ""
    COBEFFDT: any
    COBPCN: string = ""
    COBTERMDT: any
    COMPLETEIND: boolean
    CONF: string = ""
    CONTRACT: string = ""
    CUID: string = ""
    CULTURE: string = ""
    EFFDT: any
    EFTTYPE: string = ""
    ELECTION: string = ""
    FININSTNAME: string = ""
    HICN: string = ""
    LANG: string = ""
    LEGREPEMAIL: string = ""
    LTCFACILITY: string = ""
    LTCPHONE: string = ""
    MAILADD1: string = ""
    MAILADD2: string = ""
    MAILCITY: string = ""
    MAILST: string = ""
    MAILZIP: string = ""
    MEDA: any
    MEDB: any
    StrMEDA: string
    StrMEDB: string
    NOTES: string = ""
    OTHCVRG: string = ""
    OTHCVRGGRP: string = ""
    OTHCVRGID: string = ""
    OTHCVRGNAME: string = ""
    PLANNAME: string = ""
    PLANST: string = ""
    PLANTYPE: string = ""
    PLANYEAR: string = ""
    POA: string = ""
    PWO: string = ""
    ROUTINGNB: string = ""
    SEPEFFDT: any
    SEPREASONCD: number = -1
    SEPREASONTEXT: string = ""
    SOA: string = ""
    SUFFIX: string = ""
    TITLE: string = ""
    DEX: string = ""
    AGENTDEX: string = ""
    APPSIGNEDIND: boolean
    AUTHREPSIGNEDIND: boolean
    SUBMISSIONTYPECODE: string
    ADMINID: number
    ENROLLKEY: string
    USERNAME: string
    EOB: string
    UNIQUELINK: string
    // seeting radio button value in phone enrollment
    RBLRECORD: string
    RBLREP: string
    RBLBENFE: string
    RBLBENFEREPLY: string
    DATEOFRECEIPT: string
    RBLHEALTHCOVERAGE: string
    RBLHMO: string
    RBLBENEFICIARYPART: string
    AppStatus: string

    ISSINGLEGROUP: boolean
    STEPCODE: string
    AGENTORGID: number

    USERPROFILEID: number
    INSURANCECOMPID: number
    POVERIND: string
    BENEFICIARYSIGN: string
    BENEFICIARYDATE: string
    BGCHECK: boolean
    TYPEID: number
    SELAPPOINTMENTREP: string
    ISDISABLED: boolean
    CC: string
    UNMTHS: string
    SECMBRID: string
    RELCD: string
    FAMILYID: string
    PERSONCD: string
    PLANTYPENAME: string
    SELREASONCODE: number
    STEEREDIND: boolean

    // Race and Ethnicity
    selecteRace: RaceData[]
    selectedEthnicity: EthnicityData[]
    displayRace: string
    displayEthnicity: string
    Race: string
    Ethnicity: string

    CURRENTGENDER: string
    CURRENTGENDEROTH: string
    GENDERNPRONOUN: string
    GENDERNPRONOUNOTH: string

    //Relationship to Enrollee
    INDREPNAME: string = ""
    RELTOENROLL: string = ""
    NPN: string = ""
    INDREPIND: string = ""
    displayRELTOENROLL: string = ""
}
